/* eslint-disable @typescript-eslint/no-empty-function */
import './ScenarioDetailPage.css'

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageScaffold from '../../components/PageScaffold';
import { Card } from 'antd';

import ScenariosContext from '../../contexts/data/ScenariosContext';
import { ContextStatus } from '@leedpulse-monorepo/enums';

import { ScenarioCreationFormProvider } from '../../contexts/forms/scenarios/ScenarioCreationFormContext';
import { ScenarioEditionFormProvider } from '../../contexts/forms/scenarios/ScenarioEditionFormContext';

import ScenarioCreationForm from '../../components/scenario_detail_page/ScenarioCreationForm';
import { DOMAINS_PAGE_PATH } from '../domains/DomainsPage';
import ScenarioDetails from '../../components/scenario_detail_page/ScenarioDetails';
import SubscriptionsContext from '../../contexts/data/SubscriptionsContext';
import ScenarioChatPanel from '../../components/scenario_detail_page/ScenarioChatPanel';
import { useNavigate } from 'react-router-dom';

interface ScenarioDetailPageProps {
  isCreateMode: boolean;
}

// This one is different from the others as it targets directly the detail
export const SCENARIO_PAGE_PATH = '/scenario';

const ScenarioDetailPage: React.FC<ScenarioDetailPageProps> = ({
  isCreateMode,
}) => {
  const scenariosContext = useContext(ScenariosContext);
  const subscriptionsContext = useContext(SubscriptionsContext);
  const navigate = useNavigate();

  const [isDemoVisible, setIsDemoVisible] = useState(true);

  const { domainId, scenarioId } = useParams<{ domainId: string; scenarioId: string }>();

  const selectionMismatch =
    (!isCreateMode && scenariosContext.selected === null) ||
    (!isCreateMode && scenariosContext.selected?.id !== scenarioId);

  useEffect(() => {
    if (
      selectionMismatch &&
      scenariosContext.selectionStatus !== ContextStatus.LOADING
    ) {
      scenariosContext.fetchAndSelectById(scenarioId!);
    }

    return () => {
      scenariosContext.reset();
    };
  }, []);

  useEffect(() => {
    if (subscriptionsContext.status !== ContextStatus.LOADING) {
      subscriptionsContext.fetchSubscriptionsOnly("name", "asc", 10000);
    }
    return () => {
      subscriptionsContext.reset();
    };
  }, []);


  if(!domainId && !isCreateMode) {
    navigate(DOMAINS_PAGE_PATH);
    return;
  }

  if(!scenarioId && !isCreateMode) {
    navigate(`${DOMAINS_PAGE_PATH}/${domainId}`);
    return;
  }

  return (
    <PageScaffold
      title={isCreateMode ? 'Nouveau scénario' : scenariosContext.selected?.name || ''}
      subtitle={
        isCreateMode
          ? 'Ajoutez un nouveau scénario'
          : 'Consultez et modifiez les informations du scénario'
      }
      breadcrumbItems={[
        {
          target: `${DOMAINS_PAGE_PATH}/${domainId}`,
          title: 'Domaine',
        },
        {
          title: isCreateMode ? 'Nouveau' : scenariosContext.selected?.name || '',
        },
      ]}
    >
      {isCreateMode ? (
        <ScenarioCreationFormProvider>
          <ScenarioCreationForm domainId={domainId!} />
        </ScenarioCreationFormProvider>
      ) : selectionMismatch || scenariosContext.selected == null ? (
        <Card loading />
      ) : (
        <div className='scenario-detail-page-content'>
          <div className='scenario-detail-page__form-container' style={isDemoVisible ? undefined : {width: '100%'}}>
            <ScenarioEditionFormProvider>
              <ScenarioDetails scenario={scenariosContext.selected} onDemoChangeVisibility={(isVisible) => setIsDemoVisible(isVisible)} />
            </ScenarioEditionFormProvider>
          </div>
          {
            isDemoVisible ?
              <div className='scenario-detail-page__chat-container'>
                <ScenarioChatPanel scenario={scenariosContext.selected} />
              </div> : null
          }
        </div>
      )}
    </PageScaffold>
  );
};

export default ScenarioDetailPage;
